// frontend/src/config/api/endpoints/erpEndpoints.ts
/**
 * Pensado por: Alcélio Gomes
 * Codificado em coautoria: Claude Code
 * 🚀 NeuroAgentes
 * 
 * AUDITORIA: Endpoints do módulo ERP.
 */

export const erpEndpoints = {
  dashboard: '/api/erp/inventory/dashboard',
  products: '/api/erp/inventory/products',
  productById: (id: string) => `/api/erp/inventory/products/${id}`,
  createProduct: '/api/erp/inventory/products',
  updateProduct: (id: string) => `/api/erp/inventory/products/${id}`,
  deleteProduct: (id: string) => `/api/erp/inventory/products/${id}`,
  restoreProduct: (id: string) => `/api/erp/inventory/products/${id}/restore`,
  adjustStock: '/api/erp/inventory/stock/adjust',
  stockHistory: (productId: string) => `/api/erp/inventory/stock/history/${productId}`,
  stockAlerts: '/api/erp/inventory/stock/alerts',
  updatePrices: '/api/erp/inventory/prices/update',
  bulkUpdatePrices: '/api/erp/inventory/prices/bulk-update',
  priceHistory: (productId: string) => `/api/erp/inventory/prices/history/${productId}`,
  createSale: '/api/erp/sales',
  sales: '/api/erp/sales',
  saleById: (id: string) => `/api/erp/sales/${id}`,
  searchProductsForPOS: '/api/erp/sales/products/search',
  dailyReport: '/api/erp/sales/reports/daily',
  periodReport: '/api/erp/sales/reports/period',
  salesDashboard: '/api/erp/sales/dashboard',
  nextSaleNumber: '/api/erp/sales/next-number',
  calculateChange: '/api/erp/sales/calculate-change',
  createCompra: '/api/erp/compras',
  compras: '/api/erp/compras',
  compraById: (id: string) => `/api/erp/compras/${id}`,
  updateCompra: (id: string) => `/api/erp/compras/${id}`,
  deleteCompra: (id: string) => `/api/erp/compras/${id}`,
  comprasDashboard: '/api/erp/compras/dashboard',
  inventoryReport: '/api/erp/inventory/reports',
  salesReport: '/api/erp/reports/sales',
  profitReport: '/api/erp/reports/profit',
  stockMovementReport: '/api/erp/reports/stock-movement',
  categories: '/api/erp/categories',
  categoryById: (id: string) => `/api/erp/categories/${id}`,
  caixas: '/api/erp/caixas',
  caixaById: (id: string) => `/api/erp/caixas/${id}`,
  caixaByEstacao: (estacaoId: string) => `/api/erp/caixas/estacao/${estacaoId}`,
  validateCaixa: (estacaoId: string) => `/api/erp/caixas/estacao/${estacaoId}/validate`,
  printConfig: (estacaoId: string) => `/api/erp/caixas/estacao/${estacaoId}/print-config`,
  printJobs: '/api/erp/print-jobs',
  printJobById: (id: string) => `/api/erp/print-jobs/${id}`,
  printJobStatus: (id: string) => `/api/erp/print-jobs/${id}/status`,
  printStats: '/api/erp/print-jobs/stats',
  health: '/api/erp/health',
  permissions: '/api/erp/permissions',
};
